import React, { Component } from 'react';
import { Radio, Form, Tooltip, Icon, Switch, Button } from 'antd';
import { language } from '../../../language';
import { ShowProducts } from './show-products';
import { ShowContent } from './show-content';
import ProductMore from './product-more';
import { FormItemLayout, ConfigFormDecorator } from '../../tools';
import './index.less';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

export interface IProductMore {
    pic: string;
    title: string;
    text: string;
    border: boolean;
    linkParams: any;
    linkType: string;
}
/**
 * 商品列表组件-配置信息
 *  */
class ProductCardCom extends Component<any> {
    state = {
        templateId: this.props.value.showStyle || '1',
    };

    handleClickTemplates = (id: string) => {
        const { form, onChange } = this.props;
        const formValue = form.getFieldsValue();

        this.setState(
            {
                templateId: id,
            },
            () => onChange({ ...formValue, showStyle: id })
        );
    };

    productMoreChange = (value: IProductMore) => {
        const { getFieldsValue } = this.props.form;
        const { onChange } = this.props;
        onChange({ ...getFieldsValue(), productMore: value });
    };
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const {
            selector,
            uploadAction,
            linkTypes,
            linkTypeMode,
            sourceRoot,
            hideMarketPrice,
            value,
        } = this.props;
        console.log(this.props, '---==--=>', this.props.form);
        const { showContentBox } = this.props.value;
        console.log(showContentBox);
        const templates = [
            {
                id: '1',
                name: '列表',
            },
            {
                id: '2',
                name: '大图模式',
            },
            {
                id: '3',
                name: '一行两个',
            },
            {
                id: '4',
                name: '一行三个',
            },
            {
                id: '6',
                name: '一大两小',
            },
            {
                id: '5',
                name: '横向滚动',
            },
        ];
        return (
            <Form className="editor-products">
                <FormItem
                    className="fromStyle"
                    {...FormItemLayout}
                    label={language.getText('components.Products.showStyle')}
                >
                    {[
                        getFieldDecorator('showStyle', {}),
                        templates.map((item) => (
                            <Button
                                type={this.state.templateId === item.id ? 'primary' : 'default'}
                                shape="round"
                                // style={{ marginLeft: item.left }}
                                style={{ marginRight: '10px' }}
                                key={item.id}
                                onClick={() => this.handleClickTemplates(item.id)}
                            >
                                {item.name}
                            </Button>
                        )),
                    ]}
                </FormItem>
                {/* {getFieldValue('showStyle') === '5' && (
                    <FormItem {...FormItemLayout} label={'是否显示更多'}>
                        {getFieldDecorator('showMore', {
                            initialValue: false,
                        })(
                            <RadioGroup className="show-style">
                                <Radio value={false}>否</Radio>
                                <Radio value={true}>是</Radio>
                            </RadioGroup>
                        )}
                    </FormItem>
                )} */}
                {/* {getFieldValue('showStyle') === '5' && getFieldValue('showMore') && (
                    <FormItem {...FormItemLayout} label="更多配置">
                        <ProductMore
                            sourceRoot={sourceRoot}
                            value={this.props.value.productMore}
                            onChange={this.productMoreChange}
                            selector={selector}
                            uploadAction={uploadAction}
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                        />
                    </FormItem>
                )} */}
                {/* 样式 */}
                {getFieldValue('showStyle') === '5' ? (
                    <FormItem {...FormItemLayout} label="样式">
                        {getFieldDecorator('fillStyle', {
                            initialValue: 3,
                        })(
                            <RadioGroup className="show-style">
                                <Radio value={2}>一行两个半</Radio>
                                <Radio value={3}>一行三个半</Radio>
                            </RadioGroup>
                        )}
                    </FormItem>
                ) : null}
                {/* 商品 */}
                <FormItem
                    {...FormItemLayout}
                    label={
                        <span>
                            <Tooltip title={language.getText('components.Products.dragTips')}>
                                <Icon type="question-circle-o" />
                            </Tooltip>
                            &nbsp;
                            {language.getText('components.Products.products')}
                        </span>
                    }
                >
                    {getFieldDecorator('entry', {
                        initialValue: [],
                    })(<ShowProducts selector={selector} />)}
                </FormItem>
                {/* 显示内容 */}
                <FormItem
                    {...FormItemLayout}
                    label={language.getText('components.Products.content')}
                >
                    {getFieldDecorator('showContent', {
                        initialValue: [],
                    })(
                        <ShowContent
                            getFieldDecorator={getFieldDecorator}
                            hideMarketPrice={hideMarketPrice}
                            contentBox={showContentBox}
                        />
                    )}
                </FormItem>
                {/* 横向滚动添加更多配置 */}
                {/* {getFieldValue('showStyle') != '2' && (
                    <FormItem {...FormItemLayout} label={'是否显示更多'}>
                        {getFieldDecorator('showMore', { valuePropName: 'checked' })(<Switch />)}
                    </FormItem>
                )} */}
                {/* <FormItem {...FormItemLayout} label="更多配置">
                    <ProductMore
                        sourceRoot={sourceRoot}
                        value={this.props.value.productMore}
                        onChange={this.productMoreChange}
                        selector={selector}
                        uploadAction={uploadAction}
                        linkTypes={linkTypes}
                        linkTypeMode={linkTypeMode}
                    />
                </FormItem> */}
            </Form>
        );
    }
}

export const ProductCard = ConfigFormDecorator(ProductCardCom);
